import { useAppSelector } from "../../store/storeHooks"
import { selectEffectiveServiceCenterId, selectEffectiveUserType } from "../../context/contextSelectors"
import { UserType } from "../../login/loginTypes"

export function useCurrentServiceCenter() {
    const userType = useAppSelector(selectEffectiveUserType)
    const serviceCenterId = useAppSelector(selectEffectiveServiceCenterId)

    if (userType !== UserType.SERVICE_CENTER) {
        throw new Error("Invalid state: not currently acting as a service center")
    }
    if (!serviceCenterId) {
        throw new Error("Invalid state: effective service center id not found")
    }

    return {
        serviceCenterId
    }
}
